import AddCircleRoundedIcon from "@mui/icons-material/AddCircleRounded";
import DeleteIcon from "@mui/icons-material/Delete";
import { Grid, IconButton } from "@mui/material";
import { FormikTextField } from "@shared";
import { ClientPersonalDataMaxLength } from "@shared";
import { FormikProps } from "formik";

import { EditClientType } from "@/pages/clients/client/components/tabs/master-data-tab/views/personal-data/EditClient.types";
import { ContactDetailsField } from "@/pages/clients/client/components/tabs/master-data-tab/views/personal-data/sections/address/hooks/useContactDetails";
import { useTranslation } from "@/translations";

interface Props {
  formik: FormikProps<EditClientType>;
  fieldName: ContactDetailsField;
  index: number;
  valueLabel: string;
  addLabel: string;
  removeLabel: string;
  onAdd: () => void;
  onRemove: () => void;
}

export const ContactDetailRow = ({
  formik,
  fieldName,
  index,
  valueLabel,
  addLabel,
  removeLabel,
  onAdd,
  onRemove,
}: Props) => {
  const { t } = useTranslation();
  const isInputEmpty = !formik.values[fieldName][0]?.value.trim();

  return (
    <Grid size={12}>
      <Grid container columnSpacing={2} alignItems={"flex-start"}>
        <Grid size="grow">
          <FormikTextField
            formik={formik}
            path={`${fieldName}.${index}.value`}
            label={valueLabel}
            fullWidth
            slotProps={{
              input: { inputProps: { maxLength: ClientPersonalDataMaxLength.contactDetail.value } },
            }}
          />
        </Grid>
        <Grid size="grow">
          <FormikTextField
            formik={formik}
            path={`${fieldName}.${index}.comment`}
            label={t("clients.client.masterData.personalData.comment")}
            fullWidth
            slotProps={{
              input: { inputProps: { maxLength: ClientPersonalDataMaxLength.contactDetail.comment } },
            }}
          />
        </Grid>
        <Grid size="auto" sx={{ flexShrink: 0 }}>
          {index === 0 ? (
            <IconButton aria-label={addLabel} onClick={onAdd} size="medium" disabled={isInputEmpty}>
              <AddCircleRoundedIcon fontSize="medium" />
            </IconButton>
          ) : (
            <IconButton aria-label={removeLabel} onClick={onRemove} size="medium">
              <DeleteIcon fontSize="medium" />
            </IconButton>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};
